import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ListItem, ListItemIcon, ListItemText, Tooltip, Typography } from '@mui/material';

import { ProviderIcon } from '@components/content';
import { Time } from '@enums/Time';
import { DetailedPlaybackOption } from '@models/Title';
import { AvailabilityMap, getAvailability } from '@utils/availabilityUtils';
import { formatDate } from '@utils/dateUtils';

type EpisodeAiringTimeDisplayProps = {
  playbackOption: DetailedPlaybackOption;
};

const EpisodeAiringTimeDisplay: FC<EpisodeAiringTimeDisplayProps> = ({ playbackOption }) => {
  const { t } = useTranslation();

  const airing = getAvailability(playbackOption.startTime, playbackOption.endTime);
  const available = getAvailability(playbackOption.availableFrom, playbackOption.availableTo);
  const airingMap = AvailabilityMap[airing];

  return (
    <Tooltip
      key={JSON.stringify(playbackOption)}
      placement='left'
      title={
        available === Time.NOW ? (
          <Trans
            components={{ strong: <strong /> }}
            i18nKey={t('availableToTime', {
              time: formatDate(playbackOption.availableTo),
            })}
          />
        ) : undefined
      }
    >
      <ListItem className='no-hover' dense disableGutters disablePadding>
        <ListItemIcon>
          <ProviderIcon
            providerIdentifier={playbackOption.providerIdentifier}
            size='medium'
            variant='rounded'
          />
        </ListItemIcon>

        <ListItemText>
          <Typography color={airingMap.textColor} noWrap variant='inherit'>
            {t('airingTime', {
              time: formatDate(playbackOption.startTime),
              context: airing,
            })}
          </Typography>
        </ListItemText>
      </ListItem>
    </Tooltip>
  );
};

export default EpisodeAiringTimeDisplay;
